
export const reasonNotesOptions = {
    advances: "ANTICIPOS",
    discount: "DESCUENTO EN LITROS",
    buildings: "EDIFICIOS",
    foreign: "EXTRANJERO",
    fivePerThousand: "5 AL MILLAR",
}

export const typePayment = {
    ppd: "PPD",
    pue: "PUE"
}

export const receiverDefaults = {
    toBeDefined: "99",
    rfcForeign: "XEXX010101000",
    regimeForeign: "616",
    satUsageForeign: "S01",
    cpForeign: "N/A",
    satCodesNoPaymentMethod: ["15", "00", "0"],
}

export const conceptLabels = {
    grouped: "AGRUPADO",
}

export const discountTypes = {
    liters: "LT",
}

export const addNotesConfig = {
    title: "Agregar notas",
    fields: {
        date: {
            label: "Fecha",
            type: "datetime-local",
            name: "date",
        },
        idReason: {
            label: "Motivo",
            name: "idReason",
        },
        invoiceKey: {
            label: "Web ID",
            name: "invoiceKey",
        },
        folio: {
            label: "Folio",
            name: "folio",
        },
        quantity: {
            label: "Cantidad Lts",
            name: "quantity",
        },
        decimals: {
            label: "Decimales",
            name: "decimals",
        },
        price: {
            label: "PU sin IVA",
            name: "price",
        },
        subTotal: {
            label: "Sub total",
            name: "subTotal",
        },
        iva: {
            label: "IVA",
            name: "iva",
        },
        concept: {
            label: "Concepto",
            name: "grouped",
        },
        total: {
            label: "Total",
            name: "total",
        },
        discount: {
            label: "Descuento",
            name: "discountAmount",
        },
        subTotalWithDiscount: {
            label: "Subtotal con descuento",
            name: "subTotalWithDiscount",
        },
        totalWithDiscount: {
            label: "Total con descuento",
            name: "totalWithDiscount",
        },
        retention: {
            label: "5 al millar",
            name: "retention",
        },
        totalRetention: {
            label: "Total con retención",
            name: "totalRetention",
        },
        totalWithoutRetention: {
            label: "Total sin retención",
        },
    },
    tooltips: {
        searchNote: "Buscar nota",
        clean: "Limpiar",
    },
    buttons: {
        recalculate: "Recalcular notas agregadas",
        add: "Agregar",
    }
}

export const cashInvoiceConfig = {
    title: "Facturas de contado",
    modalTitle: [
        "No hay notas registradas",
        "¿Estas seguro de realizar esta acción?",
        "Por favor completa los campos"
    ],
}

export const columnsConfig = {
    folio: {
        label: "Folio",
        name: "folio",
    },
    quantity: {
        label: "Cant.",
        name: "quantity",
    },
    price: {
        label: "PU sin IVA",
        name: "price",
    },
    subTotal: {
        label: "Sub total",
        name: "subTotal",
    },
    iva: {
        label: "IVA",
        name: "iva",
    },
    total: {
        label: "Total",
        name: "total",
    },
    actions: {
        label: "Acciones",
        ButtonTooltip: "Remover nota",
    }
}

export const commentsConfig = {
    title: "Observaciones",
    label: "Comentarios",
    name: "comment",
    buttonName: "Facturar"
}

export const receiverConfig = {
    title: "Receptor",
    fields: {
        searchCustomer: {
            label: "Buscar cliente por RFC",
            name: "searchCustomer",
            Tooltip: "Buscar datos fiscales",
            cleanTooltip: "Eliminar Búsqueda"
        },
        companyName: {
            labelForeign: "Razón social extranjera",
            label: "Razón social",
            name: "companyName"
        },
        rfc: {
            label: "RFC",
            name: "rfc",
            tooltipCancel: "Cancelar edición",
            tooltip: "Editar datos"
        },
        regime: {
            label: "Regimen",
            name: "regime"
        },
        paymentType: {
            label: "Forma de pago",
            name: "paymentType"
        },
        paymentMethod: {
            label: "Tipo de pago",
            name: "paymentMethod"
        },
        satUsage: {
            label: "Uso CFDI",
            name: "satUsage"
        },
        cp: {
            label: "Código postal",
            name: "cp"
        }
    }
}

export const transmitterConfig = {
    title: "Emisor",
    fields: {
        idCompany: {
            label: "Empresa",
            name: "idCompany"
        },
        rfc: {
            label: "RFC",
            name: "rfc"
        },
        permission: {
            label: "Permiso",
            name: "permission"
        },
        series: {
            label: "Serie",
            name: "series"
        },
        logo: {
            label: "Seleccione logo",
            name: "logo"
        },
        invoiceConcept: {
            label: "Concepto específico",
            name: "invoiceConcept"
        }
    }
}